// PRE-SURGICAL NUTRITION (LWC Pre-Surgical 4.1) — 3-up row beneath the
// featured Nourish Bowl block. Rendered with LegoL99EData.
//
// Final S3 assets per Jim's TO-1716 comment (uploaded 9/23, all URLs 200).
import { pdf2026, thumb2026 } from "./assets";

const CAT = "Pre-Surgical Nutrition";

const preSurgicalNutritionCards = [
  {
    title: "How to Make a Filling Salad",
    pdf: pdf2026(CAT, "How to Make a Filling Salad.pdf"),
    thumb: thumb2026("Pre-Surgical Filling Salad.jpg"),
  },
  {
    title: "Lifestyle Medicine: Smoothie Recipe",
    pdf: pdf2026(CAT, "Lifestyle Medicine Smoothie Recipe.pdf"),
    thumb: thumb2026("Pre-Surgical Smoothie Recipe.jpg"),
  },
  {
    title: "Plant-Based Snack Options",
    pdf: pdf2026(CAT, "Plant-Based Snack Options.pdf"),
    thumb: thumb2026("Pre-Surgical Plant-Based Snack Options.jpg"),
  },
];

export default preSurgicalNutritionCards;
